<ul *ngIf="CanViewDetails" class="inline evidence">
    <li [ngClass]="[canShowEvidence(cplCycle) ? 'enabled' : '', getAttachmentsState(cplCycle)]"
        [class.hidden-slot]="!isEvidenceApplicable(complianceItem, cplCycle)">
        <button type="button"
                class="btn btn-link p-0"
                [disabled]="!canShowEvidence(cplCycle)"
                (click)="canShowEvidence(cplCycle) ? viewDetails(cplCycle, NavigationItemId.EVIDENCE) : null"
                [ngbTooltip]="getAttachmentsTooltip(cplCycle)"
                [attr.aria-label]="getAttachmentsTooltip(cplCycle)">
            <edl-icon name="paperclip" [size]="16" [ariaHidden]="true"></edl-icon>
            <span class="requirement-badge" [ngClass]="getAttachmentsBadge(complianceItem, cplCycle)" aria-hidden="true"></span>
        </button>
    </li>
    <li [ngClass]="[!!cplCycle?.QfmID ? 'enabled' : '', getQuestionnaireState(cplCycle)]"
        [class.hidden-slot]="!isQuestionnaireApplicable(cplCycle)">
        <button type="button"
                class="btn btn-link p-0"
                [disabled]="!cplCycle?.QfmID"
                (click)="cplCycle?.QfmID ? viewDetails(cplCycle, NavigationItemId.QUESTIONNAIRE) : null"
                [ngbTooltip]="getQuestionnaireTooltip(cplCycle)"
                [attr.aria-label]="getQuestionnaireTooltip(cplCycle)">
            <edl-icon name="list" [size]="16" [ariaHidden]="true"></edl-icon>
            <span class="requirement-badge" [ngClass]="getQuestionnaireBadge(complianceItem, cplCycle)" aria-hidden="true"></span>
        </button>
    </li>
    <li *ngIf="canShowNotes" [ngClass]="['enabled', getNotesState(cplCycle)]">
        <button type="button"
                class="btn btn-link p-0"
                (click)="viewDetails(cplCycle, NavigationItemId.NOTES)"
                [ngbTooltip]="getNotesTooltip(cplCycle)"
                [attr.aria-label]="getNotesTooltip(cplCycle)">
            <edl-icon name="file-lines" [size]="16" [ariaHidden]="true"></edl-icon>
        </button>
    </li>
    <li class="enabled">
        <button type="button"
                class="btn btn-link p-0"
                (click)="viewDetails(cplCycle, NavigationItemId.DETAILS)"
                ngbTooltip="View Details"
                aria-label="View details">
            <edl-icon name="info-circle" [size]="16" [ariaHidden]="true"></edl-icon>
        </button>
    </li>
</ul>
